module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "point-saved-step"
    }
  }, [_c('step-template', [_c('div', {
    staticClass: "mb-6"
  }, [_vm._v("Thank you. Your image has been added to the map successfully.")]), _vm._v(" "), _c('div', [_c('csf-button', {
    staticClass: "mb-4 mr-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.viewPoint
    }
  }, [_vm._v("View my pin")])], 1), _vm._v(" "), _c('div', [_c('csf-button', {
    staticClass: "mb-4 mr-4",
    on: {
      "click": _vm.browse
    }
  }, [_vm._v("Browse all pins")])], 1), _vm._v(" "), _c('div', [_c('csf-button', {
    staticClass: "mb-4",
    on: {
      "click": _vm.openFL
    }
  }, [_c('span', {
    staticClass: "pr-3"
  }, [_vm._v("←")]), _vm._v("Return to FutureLearn")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09057670","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/PointSavedStep.vue
// module id = 165
// module chunks = 0